// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3NOlg","title":"FrontImage_title__PN2MF"};